import {Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit, EventEmitter, Output} from '@angular/core';
import { SystemGlobalsService, Role } from './../system-globals.service';
import { SupportRequestComponent } from './../support-request/support-request.component';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})

export class TopMenuComponent implements OnInit {

  @ViewChild('navbar', {static:true}) navbar: ElementRef;
  @Output() mobileNavToggle = new EventEmitter()
  @Input() contentRef : ElementRef;

  showRoleDropdown: boolean = false;
  showUserActionsDropdown: boolean = false;
  showSupportRequestDropdown: boolean = false;

  selectedRole: Role = this.globals.constants._g_userRole;
  currentRole: Role = this.globals.constants._g_userRole;

  roleOptions = Role;
  rolesAvailable: Role[] = this.globals.constants.roleOptions;
  userId: number = this.globals.constants._g_userID;
  networkUserId = this.globals.constants['networkOwnerId']

  constructor(public globals: SystemGlobalsService) { }

  ngOnInit() {



    this.globals.getTopHeaderRef(this.navbar);
    this.globals.getMainContentRef(this.contentRef);
  }


  setSelectedRole(id: Role): void {
    this.selectedRole = id;

    //setTimeout(function() {
        let _form: any = document.getElementById('toggleRoleForm');
        _form.submit();
    //}, 100);
  }

  toggleUserActionsDropdown(): void {
    this.showUserActionsDropdown = !this.showUserActionsDropdown;
  }

  toggleRoleDropdown(): void {
    this.showRoleDropdown = !this.showRoleDropdown;
  }

  toggleSupportRequestDropdown(): void {
    this.showSupportRequestDropdown = !this.showSupportRequestDropdown;
  }

  showHelpButton(): boolean {
    return this.globals.constants._g_userRole == Role.Training_Developer || this.globals.constants._g_userRole == Role.Registrar || this.globals.constants._g_userRole == Role.Communications || this.globals.constants._g_userRole == Role.Student;
  }

  helpUrl(): string {
    return '/main/help/overview'
    // if (this.globals.constants._g_userRole == Role.Training_Developer || this.globals.constants._g_userRole == Role.Registrar) return '/help/quick_start_guide';
    // if (this.globals.constants._g_userRole == Role.Communications) return '/help/memos';
  }

  showSupportRequestModal(modal: ModalDirective) {
    alert("WE’RE MAKING HELP EASIER TO GET! \n\n This ’Support Request’ feature will be gone soon. In its place, just click the blue ‘HELP’ link to open the interactive Help system." +
      " You can search for an answer there, or at any time click ‘Ask’ to get the simplified support request form.  The same great tech support service - just quicker and easier to access!");

    modal.show();
  }

  toggleMobileNav(){

      this.mobileNavToggle.emit()
  }

}
